let sharedAudioContext: AudioContext | null = null;
let workletModulePromise: Promise<void> | null = null;

const getOrCreateAudioContext = () => {
  sharedAudioContext ??= new AudioContext({ sampleRate: 16_000 });
  return sharedAudioContext;
};

export const unlockSpeechAudioContext = () => {
  const context = getOrCreateAudioContext();
  if (context.state === 'suspended') void context.resume();
};

export const playSpeechAudio = async (audio: ArrayBuffer, signal?: AbortSignal, onStarted?: () => void): Promise<void> => {
  signal?.throwIfAborted();
  const context = getOrCreateAudioContext();
  const buffer = await context.decodeAudioData(audio);
  signal?.throwIfAborted();
  if (context.state === 'suspended') await context.resume();
  signal?.throwIfAborted();
  if (context.state !== 'running') throw new Error('音声の再生を開始できません');
  const source = context.createBufferSource();
  source.buffer = buffer;
  source.connect(context.destination);
  await new Promise<void>((resolve, reject) => {
    const cleanup = () => {
      source.onended = null;
      source.disconnect();
      signal?.removeEventListener('abort', abort);
    };
    const abort = () => {
      source.stop();
      cleanup();
      reject(new DOMException('Flow execution aborted', 'AbortError'));
    };
    source.onended = () => {
      cleanup();
      resolve();
    };
    signal?.addEventListener('abort', abort, { once: true });
    let playbackStarted = false;
    try {
      source.start();
      playbackStarted = true;
      onStarted?.();
    } catch (error) {
      if (playbackStarted) source.stop();
      cleanup();
      reject(error);
    }
  });
};

export const prepareSpeechAudioContext = async () => {
  const context = getOrCreateAudioContext();
  workletModulePromise ??= context.audioWorklet.addModule('/audio/pcm16-worklet.js');
  await workletModulePromise;
  if (context.state === 'suspended') await context.resume();
  if (context.state !== 'running') {
    throw new Error('マイク音声の処理を開始できません');
  }
  return context;
};
